module OnlineDPR.Application.Client.ControlPanelBwa

open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client.InvoiceComponents
open OnlineDPR.Application.Client.Template
open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations

open Elmish

type Msg =
| UpdateInvoiceUserNotes of Invoice
| UpdateSortOption of InvoiceSortOption
| InvoicePosted of Result<Invoice, string>

let update msg (model: ControlPanelBwaModel) =
    match msg with
    | UpdateInvoiceUserNotes invoice -> model, Cmd.OfPromise.either(Http.postData "/ControlPanel/UpdateInvoiceUserNotes") invoice (InvoicePosted) ((fun e -> Error(string e)) >> InvoicePosted)
    | UpdateSortOption newOption -> { model with SortOption = newOption }, []
    | InvoicePosted (Ok result) -> let updatedInvoices = ListHelper.replace (fun (x:Invoice) -> x.InvoiceId = result.InvoiceId) (fun _ -> result) model.Invoices
                                   match updatedInvoices with
                                   | Some l -> {model with Invoices = l}, []
                                   | None -> model, []
    | _ -> model, []


let viewInTemplate (model:ControlPanelBwaModel) dispatch =
    article [ Class "content"]
            [ div [ Class "title-block" ]
                  [ h3 [ Class "title" ]
                      [ str (CurrentTranslations.Translations.[TranslationKey.ControlPanel_Bwa_Title]) ] ]
              section [ Class "section" ]
                      [ div [ Class "card items" ]
                            [ div [ Class "card-block"]
                                  [ div [ Class "card-title-block" ]
                                        [ h3 [ Class "title" ]
                                             [ str (CurrentTranslations.Translations.[TranslationKey.ControlPanel_Invoices_Title]) ] ]
                                    section [ Class "section" ]
                                            [ InvoiceListComponent model.Invoices true (fun invoice -> (dispatch (Msg.UpdateInvoiceUserNotes invoice))) model.SortOption (fun newOption -> dispatch (Msg.UpdateSortOption newOption)) ] ] ] ] ]

let view (model:ControlPanelBwaModel) dispatch =
    templateView model.Template [] [] (viewInTemplate model dispatch)
